import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getAllTags } from '../../../SHARED/actions/tags.actions';
import { getContentByTag } from '../../../SHARED/actions/searchresults.actions';
import { pageViewEvent, slugify } from "../../helpers/general.helper";
import MovieListItem from "../movielistitem/movielistitem.component";
import TagListItem from "../taglistitem/taglistitem.component";
import { Helmet } from 'react-helmet';

class TagsSearchResults extends Component {

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.getAllTags();
    }

    componentDidMount() {
        pageViewEvent(`Rezultatele cautării după "${ this.props.match.params.tag }"`,window.location.href)
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.tags !== nextProps.tags) {
            const selectedTag = nextProps.tags.filter((tag) => {
                return slugify(tag.name) === this.props.match.params.tag;
            });
            this.props.getContentByTag(selectedTag[0]['id']);
        }
    }

    getResults = () => {
        return this.props.resultsByTag.map((item, i) => {

            const newItem = {};
            newItem['film_id'] = item['article_id'];
            newItem['film_title'] = item['article_title'];
            newItem['film_poster'] = item['article_image'];
            newItem['article_author_first_name'] = item['article_author_first_name'];
            newItem['article_author_last_name'] = item['article_author_last_name'];
            newItem['article_summary'] = item['article_summary'];

            return (
                <Fragment key={i}>
                    <TagListItem key={i} card={ newItem }/>
                </Fragment>
            );
        });
    };

    getContent = () => {
        return (
            <div className="container-fluid">
                <Helmet>
                    <title>Rezultatele cautării după "{ this.props.match.params.tag }"</title>
                    <meta name="description" content={`Rezultatele cautării după "${ this.props.match.params.tag }"`}/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                <div className="row">
                    <div className="col-lg-12">
                        <p className="white-text">Rezultatele cautării după "{ this.props.match.params.tag }"</p>
                        { this.getResults() }
                    </div>
                </div>
            </div>
        );

    };

    render() {
        return (
            <div className="tags-search-results">
                { this.getContent() }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tags: state.tags,
    resultsByTag: state.searchResults.resultsByTag
});

export default withRouter(connect(mapStateToProps, {getAllTags, getContentByTag})(TagsSearchResults));



// WEBPACK FOOTER //
// ./src/SHARED/components/tagssearchresults/tagssearchresults.component.js